/** Tipos de recurso — mesmos ids/labels da página Recursos (analista). */
/** Análise curricular da inscrição = mesmos motivos do recurso contra a lista. */
export const CURRICULAR_ANALYSIS_CONTEXT = 'list';

export const REJECTION_REASON_CONTEXTS = [
  { id: 'exemption', label: 'Recurso de isenção' },
  { id: 'list', label: 'Recurso contra a Lista de inscritos' },
  { id: 'preliminary_result', label: 'Recurso de Resultado Preliminar' },
  { id: 'answer_key', label: 'Recurso contra o Gabarito' },
  { id: 'special_attendance', label: 'Atendimento especial' },
];

const CONTEXT_LABEL_BY_ID = Object.fromEntries(
  REJECTION_REASON_CONTEXTS.map((c) => [c.id, c.label]),
);

export function getRejectionReasonContextLabel(contextId) {
  return CONTEXT_LABEL_BY_ID[contextId] || contextId;
}

export function formatRejectionReasonContexts(contexts) {
  if (!contexts || !contexts.length) return 'Todos os tipos de recurso';
  return contexts.map(getRejectionReasonContextLabel).join(', ');
}

/** Normaliza appeal_type / resource_type para o id de contexto (página Recursos). */
export function appealTypeToRejectionContext(appealType) {
  const t = String(appealType || '').toLowerCase();
  if (t === 'enrolled_list' || t === 'registration_list') return 'list';
  if (REJECTION_REASON_CONTEXTS.some((c) => c.id === t)) return t;
  return null;
}

export function reasonMatchesContext(reason, context) {
  if (!context) return true;
  const ctxs = reason?.contexts;
  if (!ctxs || !Array.isArray(ctxs) || ctxs.length === 0) return false;
  return ctxs.includes(context);
}

export function filterRejectionReasonsByContext(reasons, context) {
  if (!context) return Array.isArray(reasons) ? reasons : [];
  return (reasons || []).filter((r) => reasonMatchesContext(r, context));
}
